module.exports = __webpack_public_path__ + "static/media/decoracao_05.4db07ffb.jpg";